
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';

export default defineComponent({
  name: 'SelecionarModalidadeBaseCalculoIcms',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenerico } = useTelaBase();

    const state = reactive({
      listaModalidadesBaseCalculoIcms: [] as IOption[],
    });

    (async () => {
      const listaModalidadesBaseCalculoIcmsApi = await new ServicoCenarioFiscal().obterListaModalideBaseCalculoICMS();
      state.listaModalidadesBaseCalculoIcms = montaOpcoesComListaItemGenerico(listaModalidadesBaseCalculoIcmsApi);
    })();

    function obterModalidadesBaseCalculoIcms():any {
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterModalidadesBaseCalculoIcms(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varios ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
